import { render, staticRenderFns } from "./kongEditor1.vue?vue&type=template&id=cfba8770&scoped=true"
import script from "./kongEditor1.vue?vue&type=script&lang=js"
export * from "./kongEditor1.vue?vue&type=script&lang=js"
import style0 from "./kongEditor1.vue?vue&type=style&index=0&id=cfba8770&prod&lang=css"
import style1 from "./kongEditor1.vue?vue&type=style&index=1&id=cfba8770&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfba8770",
  null
  
)

export default component.exports